export default {
  // common
  ok: 'OK',
  cancel: 'Hủy',
  send: 'Gửi',
  // time
  timeJustNow: 'Vừa xong',
  timeMinutesAgo: '{n} phút trước',
  timeHoursAgo: '{n} giờ trước',
  timeYesterday: 'Hôm qua',
  // chat toolbar titles
  chatEmotion: 'Biểu tượng cảm xúc',
  chatSendImage: 'Gửi hình ảnh',
  chatSendFile: 'Gửi tệp',
  chatReceipt: 'Tin nhắn xác nhận',
  chatSendVoice: 'Gửi tin thoại',
  chatGroupInfo: 'Thông tin nhóm',
  // chat area
  chatSomeoneAtMe: 'Có người nhắc đến tôi',
  chatNewMessages: '{n} tin nhắn mới',
  chatBackToBottom: 'Về cuối',
  chatReceiptPrefix: '[Xác nhận] ',
  // message actions / tips
  chatNoMoreMessages: 'Không còn tin nhắn nào',
  chatDeleteConfirm: 'Xóa tin nhắn này?',
  chatDeleteTitle: 'Xóa tin nhắn',
  chatRecallConfirm: 'Thu hồi tin nhắn này?',
  chatRecallTitle: 'Thu hồi tin nhắn',
  chatRecalled: 'Đã thu hồi tin nhắn',
  chatLocateFail: 'Không thể tìm thấy tin nhắn gốc',
  chatResendUnsupported: 'Tin nhắn này không hỗ trợ gửi lại tự động. Vui lòng gửi lại thủ công.',
  // input disabled tips
  chatGroupDissolved: 'Nhóm đã bị giải tán',
  chatGroupQuit: 'Bạn không còn trong nhóm này',
  chatGroupBanned: 'Nhóm đã bị cấm',
  chatUserBanned: 'Tài khoản này đã bị cấm',
  chatBanReason: ', lý do: ',
  // message status / readed
  msgReaded: 'Đã đọc',
  msgUnread: 'Chưa đọc',
  msgAllReaded: 'Tất cả đã đọc',
  msgSomeReaded: '{n} người đã đọc',
  msgSending: 'Đang gửi',
  msgSendFail: 'Gửi thất bại',
  msgRecall: 'Gọi lại',
  msgMenuDelete: 'Xóa',
  msgMenuRecall: 'Thu hồi',
  // voice record
  recordTitle: 'Ghi âm giọng nói',
  recordDuration: 'Thời lượng',
  recordStart: 'Bắt đầu',
  recordPause: 'Tạm dừng',
  recordResume: 'Tiếp tục',
  recordStop: 'Dừng',
  recordPlay: 'Phát',
  recordStopPlay: 'Dừng phát',
  recordRestart: 'Ghi âm lại',
  recordSend: 'Gửi ngay',
  recordStateReady: 'Chưa bắt đầu',
  recordStateRunning: 'Đang ghi âm...',
  recordStatePaused: 'Tạm dừng ghi âm',
  recordStateStopped: 'Đã dừng ghi âm',
  msgReadedTab: 'Đã đọc ({n})',
  msgUnreadTab: 'Chưa đọc ({n})',
  // language
  langLabel: 'Ngôn ngữ',
  langZh: '中文',
  langEn: 'English'
}
